import React, { useState } from "react";
import { Card } from "@mui/material";
import { Link } from "react-router-dom";
import "./LearnPay.scss";
import { useAppSelector } from "../redux-store/store";
import sertificateImage from "../sertificateimage.png";
import tarolog from "../tarolog.png";
import diplom from "../diplom.png";
import star from "../bullet-star.png";
import mark from "../check-mark.png";
import pdfUrl from "../doc.pdf"; // Укажите путь к вашему PDF

export const LearnPay = () => {
  const tariffs = useAppSelector((state) => state.tariffsReducer.data) || [];
  const getTariff = (key: string) => tariffs.find((t) => t.key === key);
  const renderBold = (text: string) => {
    const parts = text.split("**");
    return parts.map((part, i) => (i % 2 === 1 ? <b key={i}>{part}</b> : part));
  };
  const renderLongDescription = (key: string, fallbackLines: string[]) => {
    const raw = getTariff(key)?.longDescription;
    const lines = raw ? raw.split(";") : fallbackLines;
    return lines.map((line, idx) => {
      if (line.trim() === "") {
        return <span key={idx} className={"spanStarSpacer"} />;
      }
      const trimmed = line.trim();
      if (trimmed.startsWith("^")) {
        return <span key={idx} className={"spanStarCenter"}>{renderBold(trimmed.slice(1).trim())}</span>;
      }
      if (trimmed.startsWith("-")) {
        return <span key={idx} className={"spanStarBullet"}>{renderBold(trimmed.slice(1).trim())}</span>;
      }
      return <span key={idx} className={"spanStar"}>{renderBold(line)}</span>;
    });
  };
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const openModal = (imageUrl: any) => {
    setSelectedImage(imageUrl);
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedImage("");
    setModalOpen(false);
  };
  return (
    <div className={"learnDiv"}>
      <span className={"spanLearn"}>Программы обучения</span>
      <div className={"learnProgram"}>
        <div className={"learnDescription"} id={"LearnDesck"}>
          <span className={"learnSpanKourse"}>
            {getTariff("profi")?.name || "МАТРИЦА СУДЬБЫ ПРОФИ"}
          </span>
          <p className={"learnP"}>
            {renderLongDescription("profi", ["Видеокурс — 68 уроков", "ДОСТУП НАВСЕГДА!", "Доступ к секретному чату практики консультантов.", "Методическая база обучающих материалов.", "Доступ к широкой библиотеке книг.", "Сертификат о прохождении курса.", "**ДИПЛОМ ДПО С ПРИСВОЕНИЕМ КВАЛИФИКАЦИИ** Консультант по личностному развитию с углубленной подготовкой в области архетипических систем (метод «Матрица Судьбы»)", "**Условия**", "**ВАЖНО:** Диплом о профессиональной переподготовке выдается на базе уже имеющегося у вас СРЕДНЕ-СПЕЦИАЛЬНОГО или ВЫСШЕГО образования.", "**ПОТРЕБУЕТСЯ ПРЕДОСТАВЛЕНИЕ СКРИНШОТА ДОКУМЕНТА!**", "**Выпуск ДИПЛОМА возможен для РФ, стран СНГ, стран дальнего зарубежья (нерезидент РФ).**", "**Длительность обучения: 252 ак. часа**", "**Форма обучения: Заочная с применением дистанционных образовательных технологий.**"])}
          <a style={{ fontWeight: "bold", color: "white" }} className={"spanStar"} href={pdfUrl}
             target="_blank" rel="noopener noreferrer">
            <img src={star} alt="" />Свидетельство
          </a>
        </p>
        <div>
          <span className={"spanLearnInner"}>
            Такой диплом вы получаете после окончания данного курса
          </span>
          <div className={"imgDiv"}>
            <img
              className={"imgSertificate"}
              src={diplom}
              alt="Диплом"
              onClick={() => openModal(diplom)}
            />
          </div>
          {modalOpen && (
            <div className="modal-container">
              <div className="modal-overlay" onClick={closeModal}></div>
              <div className="modal-content">
                <img src={selectedImage} alt="Full-screen" />
              </div>
            </div>
          )}
        </div>
        <div className={"divBoxPay"}>
          <div style={{ display: "flex", alignItems: "baseline", gap: 15, flexWrap: "wrap", justifyContent: "center" }}>
            {getTariff("profi")?.oldPrice ? <span className={"price"} style={{ textDecoration: "line-through", fontSize: 32 }}>{getTariff("profi")?.oldPrice} <p style={{ fontSize: 18 }}>рублей</p></span> : null}
            <span className={"price"}>{getTariff("profi")?.price ?? 21500} <p>рублей</p></span>
          </div>
          <Link
            style={{ fontWeight: "bold", fontSize: 24, width: "100%" }}
            className={"baton"}
            to={"/pay"}
            state={{
              name: getTariff("profi")?.name || "МАТРИЦА СУДЬБЫ ПРОФИ",
              price: (getTariff("profi")?.price ?? 21500) * 100
            }}
          >
            Приобрести
          </Link>
        </div>
      </div>


      <div className={"learnDescription"}>
          <span className={"learnSpanKourse"}>
            {getTariff("rodologiya")?.name || "РОДОЛОГИЯ В МАТРИЦЕ СУДЬБЫ"}
          </span>
        <p className={"learnP"}>
          {renderLongDescription("rodologiya", ["Видеокурс — 21 урок", "ДОСТУП НАВСЕГДА!", "Доступ к секретному чату учеников-практиков.", "Эксклюзивная методическая база.", "Сертификат о прохождении курса.", "**УДОСТОВЕРЕНИЕ О ПОВЫШЕНИИ КВАЛИФИКАЦИИ** Специалист по системному анализу родовых динамик с применением метода «Родология-Матрица Судьбы»", "**Условия**", "**ВАЖНО:** Удостоверение о повышении квалификации выдается на базе уже имеющегося у вас СРЕДНЕ-СПЕЦИАЛЬНОГО или ВЫСШЕГО образования.", "**ПОТРЕБУЕТСЯ ПРЕДОСТАВЛЕНИЕ СКРИНШОТА ДОКУМЕНТА!**", "**Выпуск УДОСТОВЕРЕНИЯ возможен для РФ, стран СНГ, стран дальнего зарубежья (нерезидент РФ).**", "**Длительность обучения: 96 ак. часов**", "**Форма обучения: Заочная с применением дистанционных образовательных технологий.**"])}
        </p>
        <div>
          <span className={"spanLearnInner"}>
            Такое удостоверение вы получаете после окончания данного курса
          </span>
          <div className={"imgDiv"}>
            <img
              className={"imgSertificate"}
              src={sertificateImage}
              alt="Сертификат"
              onClick={() => openModal(sertificateImage)}
            />
          </div>
          {modalOpen && (
            <div className="modal-container">
              <div className="modal-overlay" onClick={closeModal}></div>
              <div className="modal-content">
                <img src={selectedImage} alt="Full-screen" />
              </div>
            </div>
          )}
        </div>
        <div className={"divBoxPay"}>
          <span className={"price"}>{getTariff("rodologiya")?.price ?? 13500} <p>рублей</p></span>
          <Link
            style={{ fontWeight: "bold", fontSize: 24, width: "100%" }}
            className={"baton"}
            to={"/pay"}
            state={{
              name: getTariff("rodologiya")?.name || "РОДОЛОГИЯ В МАТРИЦЕ СУДЬБЫ",
              price: (getTariff("rodologiya")?.price ?? 13500) * 100
            }}
          >
            Приобрести
          </Link>
        </div>
      </div>






      <div className={"learnDescription"}>
        <span className={"learnSpanKourse"}>{getTariff("taro")?.name || "ТАРО УЭЙТА"}</span>
        <p className={"learnP"}>
          {renderLongDescription("taro", ["Видеокурс — 87 уроков", "ДОСТУП НАВСЕГДА!", "Доступ к секретному чату учеников-практиков.", "Широкая библиотека книг по Таро.", "Сертификат о прохождении курса.", "**УДОСТОВЕРЕНИЕ О ПОВЫШЕНИИ КВАЛИФИКАЦИИ** Специалист по архетипическому анализу и метафорическому консультированию", "**Условия**", "**ВАЖНО:** Удостоверение о повышении квалификации выдается на базе уже имеющегося у вас СРЕДНЕ-СПЕЦИАЛЬНОГО или ВЫСШЕГО образования.", "**ПОТРЕБУЕТСЯ ПРЕДОСТАВЛЕНИЕ СКРИНШОТА ДОКУМЕНТА!**", "**Выпуск УДОСТОВЕРЕНИЯ возможен для РФ, стран СНГ, стран дальнего зарубежья (нерезидент РФ).**", "**Длительность обучения: 155 ак. часов**", "**Форма обучения: Заочная с применением дистанционных образовательных технологий.**"])}
        </p>

        <div>
          <span className={"spanLearnInner"}>
            Такое удостоверение вы получаете после окончания данного курса
          </span>
          <div className={"imgDiv"}>
            <img
              className={"imgSertificate"}
              src={tarolog}
              alt="Сертификат"
              onClick={() => openModal(tarolog)}
            />
          </div>
          {modalOpen && (
            <div className="modal-container">
              <div className="modal-overlay" onClick={closeModal}></div>
              <div className="modal-content">
                <img src={selectedImage} alt="Full-screen" />
              </div>
            </div>
          )}
        </div>


        <div className={"divBoxPay"}>
          <span className={"price"}>{getTariff("taro")?.price ?? 13500} <p>рублей</p></span>
          <Link
            style={{ fontWeight: "bold", fontSize: 24, width: "100%" }}
            className={"baton"}
            to={"/pay"}
            state={{
              name: getTariff("taro")?.name || "ТАРО УЭЙТА",
              price: (getTariff("taro")?.price ?? 13500) * 100
            }}
          >
            Приобрести
          </Link>
        </div>
      </div>

    </div>
  <div className={"backColor otstup"}>
    <div className={"allPay"}>
      <div className={"listLearn"}>
        <Card className={"cardLearn"}>
          <span className={"spanLearnPay"}>{getTariff("profi")?.name || "МАТРИЦА СУДЬБЫ ПРОФИ"}</span>
          {getTariff("profi")?.oldPrice ? <span className={"price"} style={{ textDecoration: "line-through", flexDirection: "column" }}>{getTariff("profi")?.oldPrice} <p
            style={{ fontSize: 24, fontFamily: "Golos" }}>рублей</p></span> : null}
          <span className={"price"} style={{ flexDirection: "column" }}>{getTariff("profi")?.price ?? 21500} <p
            style={{ fontSize: 24, fontFamily: "Golos" }}>рублей</p></span>
          <ul>
            {(getTariff("profi")?.description || "Доступ к секретному чату практики консультантов.;Методическая база обучающих материалов.;Сертификат о прохождении курса.").split(";").map((item, idx) => (
              <li className={"ulPay"} key={idx}>
                <img src={mark} alt="" className={"ic"} />
                {item}
              </li>
            ))}
          </ul>
          <div className={"divBoxPay"}>
            <Link
              style={{ backgroundColor: "rgba(196, 157, 214, 1)", width: "100%" }}
              className={"batonStandart"}
              to={"/pay"}
              state={{
                name: getTariff("profi")?.name || "МАТРИЦА СУДЬБЫ ПРОФИ",
                price: (getTariff("profi")?.price ?? 21500) * 100
              }}
            >
              Приобрести
            </Link>
          </div>
        </Card>
        <Card className={"cardLearn"}>
          <span className={"spanLearnPay"}>{getTariff("rodologiya")?.name || "РОДОЛОГИЯ В МАТРИЦЕ СУДЬБЫ"}</span>
          <span className={"price"} style={{ flexDirection: "column" }}>{getTariff("rodologiya")?.price ?? 13500} <p
            style={{ fontSize: 24, fontFamily: "Golos" }}>рублей</p></span>
          <ul>
            {(getTariff("rodologiya")?.description || "Доступ к секретному чату учеников-практиков.;Эксклюзивная методическая база.;Сертификат о прохождении курса.").split(";").map((item, idx) => (
              <li className={"ulPay"} key={idx}>
                <img src={mark} alt="" className={"ic"} />
                {item}
              </li>
            ))}
          </ul>
          <div className={"divBoxPay"}>
            <Link
              style={{ backgroundColor: "rgba(196, 157, 214, 1)", width: "100%" }}
              className={"batonStandart"}
              to={"/pay"}
              state={{
                name: getTariff("rodologiya")?.name || "РОДОЛОГИЯ В МАТРИЦЕ СУДЬБЫ",
                price: (getTariff("rodologiya")?.price ?? 13500) * 100
              }}
            >
              Приобрести
            </Link>
          </div>
        </Card>
        <Card className={"cardLearn"}>
          <span className={"spanLearnPay"}>{getTariff("taro")?.name || "ТАРО УЭЙТА"}</span>
          <span className={"price"} style={{ flexDirection: "column" }}>{getTariff("taro")?.price ?? 13500} <p
            style={{ fontSize: 24, fontFamily: "Golos" }}>рублей</p></span>
          <ul>
            {(getTariff("taro")?.description || "Доступ к секретному чату учеников-практиков.;Широкая библиотека книг по Таро.;Сертификат о прохождении курса.").split(";").map((item, idx) => (
              <li className={"ulPay"} key={idx}>
                <img src={mark} alt="" className={"ic"} />
                {item}
              </li>
            ))}
          </ul>
          <div className={"divBoxPay"}>
            <Link
              style={{ backgroundColor: "rgba(196, 157, 214, 1)", width: "100%" }}
              className={"batonStandart"}
              to={"/pay"}
              state={{
                name: getTariff("taro")?.name || "ТАРО УЭЙТА",
                price: (getTariff("taro")?.price ?? 13500) * 100
              }}
            >
              Приобрести
            </Link>
          </div>
        </Card>
      </div>
    </div>
  </div>;
</div>
)
  ;
};
